import React, { useState, useEffect, useCallback } from 'react';
import Notification from '../notification'; // Adjust path to the existing Snackbar component

const ForegroundNotificationHandler = () => {
    const [notificationState, setNotificationState] = useState({
        open: false,
        message: '',
        severity: 'info',
        autoHideDuration: 5000, // Or your preferred duration
    });

    useEffect(() => {
        const handleShowNotification = (event) => {
            const { title, body, severity = 'info' } = event.detail;
            setNotificationState({
                open: true,
                message: title ? `${title}: ${body}` : body,
                severity: severity,
                autoHideDuration: severity === 'error' ? 10000 : 5000, // Longer for errors
            });
        };

        window.addEventListener('show-in-app-notification', handleShowNotification);
        return () => {
            window.removeEventListener('show-in-app-notification', handleShowNotification);
        };
    }, []);

    const handleClose = useCallback(() => {
        setNotificationState(prevState => ({ ...prevState, open: false }));
    }, []);

    return (
        <Notification
            notificationOpen={notificationState.open}
            notificationMessage={notificationState.message}
            severity={notificationState.severity}
            autoHideDuration={notificationState.autoHideDuration}
            handleNotificationClose={handleClose}
        />
    );
};

export default ForegroundNotificationHandler;
